// extracted by mini-css-extract-plugin
export default {"overlay":"zx-z","bodyOpen":"Ax-z","content":"Bx-z","header":"Cx-z","close":"Dx-z","closeNoHeading":"Ex-z"};